import {
  PublicBidStatusTransitionTypeDto,
  type BuyerPublicBidDetailDto,
  type PublicBidStatusTransitionDto,
} from "../../../../autogen/bff-api";

export type BidActivityType = "submitted" | "opened" | "rejected" | "awarded";

export interface BidActivityEvent {
  type: BidActivityType;
  at: string;
}

const typeOrder: Record<BidActivityType, number> = {
  submitted: 0,
  opened: 1,
  rejected: 2,
  awarded: 3,
};

const compareInstants = (a: string, b: string): number => Date.parse(a) - Date.parse(b);

export const latestTransition = (
  transitions: PublicBidStatusTransitionDto[] | undefined,
  type: PublicBidStatusTransitionTypeDto,
): PublicBidStatusTransitionDto | undefined =>
  [...(transitions ?? [])]
    .filter((transition) => transition.type === type)
    .sort((a, b) => compareInstants(b.at, a.at))[0];

export const getBidActivityEvents = (detail: BuyerPublicBidDetailDto): BidActivityEvent[] => {
  const transitions = detail.bid.statusHistory ?? [];
  const submittedAt =
    latestTransition(transitions, PublicBidStatusTransitionTypeDto.Submitted)?.at ?? detail.bid.submittedAt;
  const rejectedAt = latestTransition(transitions, PublicBidStatusTransitionTypeDto.Rejected)?.at;
  const awardedAt = latestTransition(transitions, PublicBidStatusTransitionTypeDto.Awarded)?.at;

  const events: BidActivityEvent[] = [
    submittedAt ? { type: "submitted", at: submittedAt } : null,
    detail.bidOpenedAt ? { type: "opened", at: detail.bidOpenedAt } : null,
    rejectedAt ? { type: "rejected", at: rejectedAt } : null,
    awardedAt ? { type: "awarded", at: awardedAt } : null,
  ].filter((event): event is BidActivityEvent => event != null);

  return events.sort((a, b) => {
    const byTimestamp = compareInstants(a.at, b.at);
    return byTimestamp !== 0 ? byTimestamp : typeOrder[a.type] - typeOrder[b.type];
  });
};
